import React, { useEffect, useState } from 'react'
import "../../stylings/gallery.css"
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

const Gallery = () => {
  const { photoGallery } = useSelector((state) => state.photoGallery)

  const [slideNumber, setSlideNumber] = useState(0)
  const [openModal,   setOpenModal]   = useState(false)
  const [imagePath,   setImagePath]   = useState([])

  const handleOpenModal  = (index) => { setSlideNumber(index); setOpenModal(true) }
  const handleCloseModal = ()      => setOpenModal(false)
  const prevSlide = () => setSlideNumber(n => (n === 0 ? imagePath.length - 1 : n - 1))
  const nextSlide = () => setSlideNumber(n => (n + 1 === imagePath.length ? 0 : n + 1))

  useEffect(() => {
    const paths = []
    photoGallery.forEach((item, idx) => {
      if (idx < 9 && item.attachments.length > 0) paths.push(item.attachments[0].path)
    })
    setImagePath(paths)
  }, [photoGallery])

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') handleCloseModal() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  const visibleItems = photoGallery.slice(0, 9)

  return (
    <section className="photo-gallery-section">

      {/* ── Lightbox ── */}
      {openModal && (
        <div className="pg-lightbox" onClick={handleCloseModal}>
          <button className="pg-lb-close" onClick={handleCloseModal} aria-label="Close">
            <i className="fa-solid fa-xmark"></i>
          </button>
          <button className="pg-lb-prev" onClick={(e) => { e.stopPropagation(); prevSlide() }} aria-label="Previous">
            <i className="fa-solid fa-chevron-left"></i>
          </button>
          <div className="pg-lb-img-wrap" onClick={(e) => e.stopPropagation()}>
            <img src={imagePath[slideNumber]} alt="Gallery" />
            <div className="pg-lb-counter">{slideNumber + 1} / {imagePath.length}</div>
          </div>
          <button className="pg-lb-next" onClick={(e) => { e.stopPropagation(); nextSlide() }} aria-label="Next">
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      )}

      <div className="container">

        {/* ── Section header ── */}
        <div className="gallery-section-header">
          <div className="gallery-section-header-left">
            <div className="gallery-section-tag">
              <i className="fa-solid fa-camera-retro"></i>
              Photo Gallery
            </div>
            <h2 className="gallery-section-title">Moments &amp; Memories</h2>
            <p className="gallery-section-subtitle">
              A glimpse into school life — celebrations, learning, sports and achievements.
            </p>
          </div>
          <Link to="/galleryall" className="gallery-view-all-btn">
            View All Albums <i className="fa-solid fa-arrow-right"></i>
          </Link>
        </div>

        {/* ── Bento Grid ── */}
        {visibleItems.length > 0 ? (
          <div className="pg-grid">
            {visibleItems.map((item, idx) => {
              const att = item.attachments?.[0]
              if (!att) return null
              const photoCount = item.attachments.length

              return (
                <div
                  key={item.id}
                  className={`pg-item pg-item-${idx + 1}`}
                  onClick={() => handleOpenModal(idx)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && handleOpenModal(idx)}
                  aria-label={`Open ${item.eventname || 'gallery image'}`}
                >
                  {/* Photo */}
                  <img src={att.path} alt={item.eventname || 'Gallery'} className="pg-img" />

                  {/* Centre zoom ring — visible on hover */}
                  <div className="pg-overlay">
                    <div className="pg-zoom-ring">
                      <i className="fa-solid fa-expand"></i>
                    </div>
                  </div>

                  {/* Footer bar — always visible */}
                  <div className="pg-footer">
                    <div className="pg-footer-left">
                      {item.eventname && (
                        <span className="pg-album-name">{item.eventname}</span>
                      )}
                      {photoCount > 1 && (
                        <span className="pg-photo-count">
                          <i className="fa-solid fa-images"></i>
                          {photoCount} Photos
                        </span>
                      )}
                    </div>
                    {/* arrow icon button — springs in on hover */}
                    <div className="pg-view-btn">
                      <i className="fa-solid fa-arrow-right"></i>
                    </div>
                  </div>

                </div>
              )
            })}
          </div>
        ) : (
          <div className="gallery-empty">
            <i className="fa-regular fa-images"></i>
            <p>No photos available yet. Check back soon!</p>
          </div>
        )}

      </div>
    </section>
  )
}

export default Gallery
